var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68643 19.8877L7.29725 24.5578C7.27741 24.7958 7.46528 25 7.70416 25C7.80416 25 7.90069 24.9633 7.97543 24.8969L12.3943 20.969L13.5731 20.9953C13.7145 20.9984 13.8568 21 14 21C17.3896 21 20.1736 20.1192 22.0406 18.6453C23.8188 17.2416 25 15.1269 25 12C25 8.87312 23.8188 6.75844 22.0406 5.35471C20.1736 3.88083 17.3896 3 14 3C10.6104 3 7.8264 3.88083 5.95936 5.35471C4.18118 6.75844 3 8.87312 3 12C3 15.2954 4.31186 17.4849 6.29501 18.8969L7.68643 19.8877ZM9.96852 27.1391L13.5062 23.9945C13.6701 23.9982 13.8347 24 14 24C21.732 24 28 20 28 12C28 4 21.732 0 14 0C6.26801 0 0 4 0 12C0 16.234 1.75571 19.3476 4.55494 21.3407L4.30761 24.3086C4.14202 26.2958 5.71016 28 7.70416 28C8.53891 28 9.34463 27.6937 9.96852 27.1391Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.054d8dde2a221faf53a1131b645ec59b.svg";
export { ForwardRef as ReactComponent };